var BxfProgressIndicatorSizeEnum;
(function (BxfProgressIndicatorSizeEnum) {
    BxfProgressIndicatorSizeEnum["LARGE"] = "large";
    BxfProgressIndicatorSizeEnum["REGULAR"] = "regular";
})(BxfProgressIndicatorSizeEnum || (BxfProgressIndicatorSizeEnum = {}));

var BxfProgressIndicatorTypeEnum;
(function (BxfProgressIndicatorTypeEnum) {
    BxfProgressIndicatorTypeEnum["BAR"] = "bar";
    BxfProgressIndicatorTypeEnum["LOADING"] = "loading";
})(BxfProgressIndicatorTypeEnum || (BxfProgressIndicatorTypeEnum = {}));

export { BxfProgressIndicatorSizeEnum as B, BxfProgressIndicatorTypeEnum as a };
